export var ButtonSizes;
(function (ButtonSizes) {
    ButtonSizes["small"] = "small";
    ButtonSizes["medium"] = "medium";
    ButtonSizes["large"] = "large";
})(ButtonSizes || (ButtonSizes = {}));
export var ButtonRoles;
(function (ButtonRoles) {
    ButtonRoles["primary"] = "primary";
    ButtonRoles["secondary"] = "secondary";
    ButtonRoles["tertiary"] = "tertiary";
    ButtonRoles["utilityPrimary"] = "utilityPrimary";
    ButtonRoles["utilityTertiary"] = "utilityTertiary";
})(ButtonRoles || (ButtonRoles = {}));
